
// profileUtils.ts

import { Listing, User } from "graphql/generated/graphql"

/**
 * Profile Utilities - Helper functions for user and listing profiles
 */
export class ProfileUtils {
  private static readonly STATIC_ASSETS = {
    producer: '/assets/icons/tractor.svg',
    general: '/assets/avatar/user-default.svg',
    default: '/assets/icons/Market.svg',
  }

  /**
   * Gets the appropriate display image URL
   * @param user User object
   * @param listing Optional listing object
   * @returns string Image URL
   */
  static getImage(user: User, listing?: Listing): string {
    // Priority 1: Listing photo
    if (listing?.photo) {
      return listing.photo
    }

    // Priority 2: User's profile photo resource
    if (user?.profile_photo_resource) {
      return user.profile_photo_resource
    }

  

    // Fallback to static assets
    const userType = user?.user_type?.toLowerCase()
    return (
      this.STATIC_ASSETS[userType as keyof typeof this.STATIC_ASSETS] ||
      this.STATIC_ASSETS.default
    )
  }

  /**
   * Gets the appropriate display name
   * @param user User object
   * @param listing Optional listing object
   * @returns string Display name
   */
  static getName(user?: User, listing?: Listing): string {
    // Priority 1: Listing name
    if (listing?.name) {
      return listing.name
    }

    // Priority 2: User's full name
    if (user?.full_name) {
      return user.full_name
    }

    // Priority 3: Username or email fallback
    if (user?.username) {
      return user.username
    }
    
    // Final fallback
    return 'Unknown'
  }

  /**
   * Gets user type icon
   * @param user User object
   * @returns string Icon URL
   */
  static getUserTypeIcon(user: User): string {
    const userType = user?.user_type?.toLowerCase()
    return (
      this.STATIC_ASSETS[userType as keyof typeof this.STATIC_ASSETS] ||
      this.STATIC_ASSETS.default
    )
  }
}
